import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { FeatureFlagsService } from '../feature-flag/feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class PlanFeatureService {
  public plan1Name: string;
  public plan2Name: string;
  public plan3Name: string;
  public plan1Benefits: string[];
  public plan2Benefits: string[];
  public plan3Benefits: string[];

  public plansFeatures = {};

  public mainCardContent = [];
  public mainCardContentForIndorCat = [];
  public mainCardContentForOutdoorCat = [];
  public smartTagMainCardContent = [];

  public brandName = '';

  constructor(
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService
  ) {
    this.brandName = this.configService.getTextFromKey('brand-plan-feature-name');
    this.plan1Benefits = this.configService.getListContentFromKey('1-plan-benefits');
    this.plan2Benefits = this.configService.getListContentFromKey('2-plan-benefits');
    this.plan3Benefits = this.configService.getListContentFromKey('3-plan-benefits');
    this.mainCardContent = this.configService.getCardListFromKey('2-plan-benefits-large');
    this.mainCardContentForIndorCat = this.configService.getCardListFromKey('2-plan-benefits-large-indoor-cat');
    this.mainCardContentForOutdoorCat = this.configService.getCardListFromKey('2-plan-benefits-large-outdoor-cat');
    this.plan1Name = this.configService.getTextFromKey('1-plan-name');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
    this.plan3Name = this.configService.getTextFromKey('3-plan-name');

    this.plansFeatures = {
      [this.plan1Name]: this.plan1Benefits,
      [this.plan2Name]: this.plan2Benefits,
      [this.plan3Name]: this.plan3Benefits,
    };
  }

  public getFeaturesFor(plan: string): any[] {
    return this.plansFeatures[plan];
  }

  public getMainPlanContent(petName: string, thereIsOnlyOneCat?: boolean, isOutdoors?: boolean) {
    if (thereIsOnlyOneCat) {
      if (isOutdoors) {
        return this.mainCardContentForOutdoorCat.map((content) => {
          return {
            ...content,
            text: content.text.replace('{petName}', petName),
          };
        });
      } else {
        return this.mainCardContentForIndorCat.map((content) => {
          return {
            ...content,
            text: content.text.replace('{petName}', petName),
          };
        }); 
      }
    }
    return this.mainCardContent.map((content) => {
      return {
        ...content,
        text: content.text
                .replace('{petName}', petName)
                .replace('{brandName}', this.brandName),
      };
    });
  }
}
